import { createAction, props } from "@ngrx/store";

export const setPumpUnitItem = createAction(
  '[Pump Unit Form] Set Pump Unit Item',
  props<{ data: string }>()
);

export const setPumpUnitPackaging = createAction(
  '[Pump Unit Form] Set Pump Unit Packaging',
  props<{ data: string }>()
);

export const setPumpUnitMaxTemp = createAction(
  '[Pump Unit Form] Set Pump Unit Max Temperature',
  props<{ data: string }>()
);

export const setPumpUnitSuctionHead = createAction(
  '[Pump Unit Form] Set Pump Unit Suction Head',
  props<{ data: string }>()
);

export const setPumpUnitPicture = createAction(
  '[Pump Unit Form] Set Pump Unit Picture',
  props<{ data: string }>()
);

export const setPumpUnitDrawing = createAction(
  '[Pump Unit Form] Set Pump Unit Drawing',
  props<{ data: string }>()
);

export const setPumpUnitPictureUrl = createAction(
  '[Pump Unit Form] Set Pump Unit Picture Url',
  props<{ data: string }>()
);

export const setPumpUnitDrawingUrl = createAction(
  '[Pump Unit Form] Set Pump Unit Drawing Url',
  props<{ data: string }>()
);
